import dev from './config.idomed.dev';
import hml from './config.idomed.hml';
import local from './config.idomed.local';
import prod from './config.idomed.prod';

export default { local, dev, prod, hml };
